import React from "react";

const STEPS = [
  {
    title: "Submit Your Idea",
    description:
      "Share your problem statement or innovation idea through the platform.",
  },
  {
    title: "Find the Right Expertise",
    description:
      "Connect with experts who can help refine, redesign and improve your concept.",
  },
  {
    title: "Build Your Prototype",
    description:
      "Access suitable facility centres and manufacturing capabilities.",
  },
  {
    title: "Compare Quotations",
    description:
      "Receive quotations from eligible centres and choose based on your budget.",
  },
  {
    title: "Protect Your Innovation",
    description:
      "Get guidance towards intellectual property and patent processes.",
  },
  {
    title: "Move to Manufacturing",
    description: "Convert prototypes into production-ready products.",
  },
  {
    title: "Scale Your Product",
    description:
      "Move from prototype to commercialisation and mass production.",
  },
  {
    title: "Get Recognition",
    description:
      "Outstanding ideas can be considered for awards and ecosystem showcases.",
  },
];

function CheckIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9.25" stroke="#16A34A" strokeWidth="1.5" />
      <path
        d="M8 12.5L10.5 15L16 9"
        stroke="#1653a3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function StepCard({ index, title, description }) {
  const number = String(index + 1).padStart(2, "0");

  return (
    <div
      style={{
        position: "relative",
        background: "#FFFFFF",
        border: "1px solid #E5EAF1",
        borderRadius: "16px",
        padding: "28px 24px",
        overflow: "hidden",
        minHeight: "190px",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.03)",
      }}
    >
      {/* Faint background number */}
      <span
        style={{
          position: "absolute",
          top: "8px",
          right: "16px",
          fontSize: "56px",
          fontWeight: 800,
          color: "#EAF7EF",
          lineHeight: 1,
          userSelect: "none",
          zIndex: 0,
        }}
      >
        {number}
      </span>

      <div style={{ position: "relative", zIndex: 1 }}>
        <div style={{ marginBottom: "14px" }}>
          <CheckIcon />
        </div>
        <h3
          style={{
            fontSize: "19px",
            fontWeight: 700,
            color: "#0B1F3A",
            margin: "0 0 10px 0",
            lineHeight: 1.3,
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontSize: "15px",
            color: "#5B6779",
            margin: 0,
            lineHeight: 1.55,
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
}

export default function InnovatorSteps() {
  return (
    <section
      style={{
        background:
          "linear-gradient(135deg, #EAF3FC 0%, #F3F8FD 45%, #E9F5FB 100%)",
        padding: "20px 24px",
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          
          <h2
            style={{
              fontSize: "44px",
              fontWeight: 800,
              color: "#0B1F3A",
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            Your Idea Deserves
           a <span style={{ color: "#1643a3" }}>Chance.</span>
          </h2>
        </div>

        {/* Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "22px",
          }}
        >
          {STEPS.map((step, i) => (
            <StepCard
              key={step.title}
              index={i}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>
      </div>

      {/* Responsive breakpoints */}
      <style>{`
        @media (max-width: 1024px) {
          section div[style*="grid-template-columns"] {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 560px) {
          section div[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
          }
          h2 {
            font-size: 32px !important;
          }
        }
      `}</style>
    </section>
  );
}